/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 */

export const getByIdEarlyRequestRpc = {
  serviceName: 'com.hubspot.academy.catalog.rpc.noauth.TrackPublicChirpService',
  rpcName: 'getById',
  auth: 'external',
  fingerprint: '8wmW0arbCOWX50P5st5Rtu-ymnNyhEw2',
  earlyRequest: true,
  na1Only: false,
  isStreaming: false
};
export const getByLanguageAndPagePathEarlyRequestRpc = {
  serviceName: 'com.hubspot.academy.catalog.rpc.noauth.TrackPublicChirpService',
  rpcName: 'getByLanguageAndPagePath',
  auth: 'external',
  fingerprint: 'cGNdIkKTAlWX50P5st5RtpwP6LXzGzX8',
  earlyRequest: true,
  na1Only: false,
  isStreaming: false
};